import 'whatwg-fetch';
const env = process.env;

const getExceptionTypes = (payload) => {
  let url = `${env.VUE_APP_trimaster}/api/v1/exceptionTypes?access_token=${payload.apitoken}`;
  if (payload.filters) {
    url += `&filter=${payload.filters}`
  }
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  });
}

const getExceptionList = (payload) => {
  let url = `${env.VUE_APP_trimaster}/api/v1/ExceptionLists?access_token=${payload.apitoken}`
  if (payload.filters) {
    url += `&filter=${payload.filters}`
  }
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  });
}

const getExceptionStatuses = (payload) => {
  let url = `${env.VUE_APP_trimaster}/api/v1/ExceptionStatuses?access_token=${payload.apitoken}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  });
}

const setExceptionRemediation = (payload) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/ExceptionRemediations?access_token=${payload.apitoken}`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
}

const getExceptionRemediations = (payload) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/ExceptionRemediations?access_token=${payload.apitoken}&filter={"include":["status","user"]}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    })
}

const updateExceptionRemediation = (payload) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/ExceptionRemediations?access_token=${payload.apitoken}`, {
        method: 'PATCH',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
}

export default {
  getExceptionTypes,
  getExceptionList,
  getExceptionStatuses,
  setExceptionRemediation,
  getExceptionRemediations,
  updateExceptionRemediation
}
